import { connect } from 'react-redux'
import * as api from '../../../actions/api'
import { EventTweetDialog } from '../components'

const mapStateToProps = (state, ownProps) => {
  const { language } = state.user
  return ({
    language
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleTweet: (record, text, datetime, checkedImage) => {
      dispatch(api.twitter.fetchTweet({
        text,
        datetime: datetime !== null ? datetime.valueOf() : undefined,
        url: checkedImage === true ? record.thumbnail : undefined,
        checkedImage: false,
        checkedSchedule: Boolean(datetime !== null),
      }))
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventTweetDialog)


// WEBPACK FOOTER //
// ./src/Pages/Event/containers/EventTweetDialog.js